import gql from 'graphql-tag';

export const AddGuests = gql`
    mutation addGuests($request: ReservationGuestsRequest!) {
        addGuests(request: $request) {
            acceptedInvite
            isPrimary
            email
            firstName
            fullName
            lastName
        }
    }
`;

export const DeleteGuests = gql`
    mutation deleteGuests($request: DeleteGuestRequest!) {
        deleteGuests(request: $request) {
            acceptedInvite
            isPrimary
            email
            firstName
            fullName
            lastName
        }
    }
`;
